module.exports = __webpack_public_path__ + "static/img/Distillery.832773e.png";